import gsap from "gsap";

class Button {
  constructor(button) {
    this.button = button;
    this.text = button.querySelector("[data-button-text]");
    this.arrow = button.querySelector("[data-button-arrow]");
    this.init();
  }

  init() {
    gsap.to(this.text, {
      rotate: 360,
      ease: "linear",
      duration: 20,
      repeat: -1,
    });

    this.button.addEventListener("mouseenter", () => {
      const tl = gsap.timeline();
      tl.to(this.arrow, {
        y: -8,
        duration: 0.2,
        ease: "power2.out",
      }).to(this.arrow, {
        y: 0,
        duration: 0.4,
        ease: "bounce.out",
      });
    });
  }
}

export default Button;
